export default __webpack_public_path__ + "static/media/btn-stage2.8cdfdfac.png";